import { Link } from '@reach/router';
import * as React from 'react';
import { ButtonFilled, Card, CardSegment } from '../ui';

const EmptyCard: React.FunctionComponent = ({ children }) => (
  <Card className="tc w-100 mw6 center mv2 mt0-ns mb5-ns" data-testid="empty-card">
    <CardSegment className="pv5">{children}</CardSegment>
  </Card>
);

export default EmptyCard;
